(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();


/* COIPLAY_BRAND_STORY_MEMORY_FIX_ASSET_20260612 */
(function () {
  function fixBrandStoryMemoryText() {
    if (window.location.pathname !== '/pages/brand-story') return;
    var cards = document.querySelectorAll('.coiplay-story-card');
    cards.forEach(function (card) {
      var heading = card.querySelector('h3');
      var paragraph = card.querySelector('p');
      if (!heading || !paragraph) return;
      if (heading.textContent.trim() === 'Pumpkin') {
        paragraph.textContent = 'Rescued at three months old, blind in one eye and battling skin disease. Bennie brought him with her when she immigrated to LA. Today he sleeps in the sun. Fat, happy, home.';
      }
      if (heading.textContent.trim() === 'In Loving Memory') {
        paragraph.innerHTML = '<strong>Milky &amp; Mini</strong> — Mini ran outside and was killed by a wolf; Milky ran outside and never came home. We couldn’t keep you safe, but we never forgot you. Every kit we make is a little bit because of you.';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixBrandStoryMemoryText);
  } else {
    fixBrandStoryMemoryText();
  }
})();

/* COIPLAY_HOME_COI0024_RUNTIME_REPLACE_20260712 */
(function coiplayHomeCoi0024RuntimeReplace() {
  function replaceCard() {
    try {
      if (window.location.pathname !== "/" && window.location.pathname !== "") return;
      var root = document.getElementById("coiplay-home-rebuild");
      if (!root) return;
      var titles = root.querySelectorAll(".cp-home-card__title");
      for (var i = 0; i < titles.length; i += 1) {
        var title = titles[i];
        if ((title.textContent || "").trim() !== "Car & Plane Art Kit") continue;
        var card = title.closest(".cp-home-card");
        if (!card) continue;
        var image = card.querySelector("img");
        if (image) {
          image.src = "https://cdn.shopify.com/s/files/1/0722/6094/4059/files/COI0024_TravelAdventure_family.jpg?v=1779778410";
          image.alt = "Travel and Adventure Combo Bookmark Craft Kit - COI0024";
        }
        title.innerHTML = "Travel &amp; Adventure Combo Kit";
        var button = card.querySelector("a.cp-home-button");
        if (button) {
          button.href = "/products/travel-adventure-combo-bookmark-craft-kit";
          button.textContent = "Shop the $29.99 Kit";
        }
        card.setAttribute("data-coiplay-home-card", "COI0024");
      }
    } catch (error) {}
  }
  replaceCard();
  document.addEventListener("DOMContentLoaded", replaceCard);
  window.addEventListener("load", replaceCard);
  setTimeout(replaceCard, 300);
  setTimeout(replaceCard, 1200);
})();

